import { render, staticRenderFns } from "./project_detail.vue?vue&type=template&id=05133aeb&scoped=true&"
import script from "./project_detail.vue?vue&type=script&lang=js&"
export * from "./project_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05133aeb",
  null
  
)

export default component.exports